"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Hint = function (props) {
    return (React.createElement("div", { className: "hint", id: props.id },
        React.createElement("i", { className: "fas fa-question-circle" }),
        React.createElement("span", { className: "hinttext" }, props.children)));
};
exports.default = Hint;
